import React from "react";
import * as Dropdown from "../../../../../../common-deprecated/styles/v2/lexus/globals/Dropdown";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { getEngineName } from "../../../../utils/formatters/nameFormatters";
import { useCompareV2Selector } from "../../../../redux/store";
import useSelectEngine from "../../../../hooks/useSelectEngine";
import { CompareV2Label } from "../../../../utils/labels";
import { MODAL_SELECT_ENGINE } from "../../../../../../shared-logic/features/compare/utils/modalConstants";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { trackCompareEngineOpen } from "../../../../utils/tracking";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

type SelectEnginePropsType = {
    index: number;
    engineSelectHeight: number;
    setEngineSelectHeight: (newHeight: number) => void;
    isPdf?: boolean;
};

const SelectEngine = (props: SelectEnginePropsType): JSX.Element => {
    const dispatch = useDispatch();
    const { index, engineSelectHeight, setEngineSelectHeight, isPdf } = props;

    const engines = useCompareV2Selector((state) => state.newCarCompare.specs[index]);
    const selectedEngine = useCompareV2Selector((state) => state.newCarCompare.selectedEngines[index]);
    const cars = useCompareV2Selector((state) => state.newCarCompare.grades);

    const { hasMultipleEngines, open, setOpen, dropDownRef } = useSelectEngine(
        engines,
        engineSelectHeight,
        setEngineSelectHeight,
    );

    return (
        <>
            <Dropdown.Title
                isPdf={isPdf}
                height={engineSelectHeight}
                selected={open}
                ref={dropDownRef}
                showPointer={hasMultipleEngines}
                onClick={() => {
                    if (hasMultipleEngines) {
                        trackCompareEngineOpen();
                        setOpen(!open);
                        dispatch(
                            showModal({
                                type: MODAL_SELECT_ENGINE,
                                index,
                            }),
                        );
                    }
                }}
            >
                {cars[index].loading ? (
                    <CompareV2Label label="compareBodyLoading" />
                ) : (
                    <>
                        {getEngineName(selectedEngine)}
                        {!isPdf && hasMultipleEngines && <Icon variant="chevronDown" />}
                    </>
                )}
            </Dropdown.Title>
        </>
    );
};

export default SelectEngine;
